import { render, staticRenderFns } from "./vehicleRepairApplyDetail.vue?vue&type=template&id=a98e3b6e&scoped=true"
import script from "./vehicleRepairApplyDetail.vue?vue&type=script&lang=js"
export * from "./vehicleRepairApplyDetail.vue?vue&type=script&lang=js"
import style0 from "./vehicleRepairApplyDetail.vue?vue&type=style&index=0&id=a98e3b6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98e3b6e",
  null
  
)

export default component.exports